import React, { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { dashboardService } from '../../services/dashboardService';

interface Props { 
  year?: string; 
  month?: string;
}

export const DocumentosCards: React.FC<Props> = ({ year, month }) => {
  const { user, isGrupo, isEmpresa } = useAuth();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    const load = async () => {
      if (!user) return;
      setLoading(true);
      try {
        const params: any = {};
        if (year) params.year = Number(year);
        if (month) params.month = Number(month);
        
        let res;
        if (isGrupo && user.grupoId) {
          // Para grupo, usar o endpoint de grupo que consolida dados de documentos
          res = await dashboardService.grupoOverview(user.grupoId, params);
        } else if (isEmpresa && user.empresaId) {
          res = await dashboardService.documentosOverview(user.empresaId, params);
        } else {
          throw new Error('Usuário não tem empresa ou grupo associado');
        }
        
        const payload = res?.data ?? res;
        setData(payload);
      } catch (err) {
        console.error('Erro ao carregar dashboard documentos:', err);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    if (user && (isEmpresa || isGrupo)) load();
  }, [user, isGrupo, isEmpresa, month, year]);

  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
      <div className="p-3 rounded shadow h-24 flex flex-col justify-between" style={{ backgroundColor: '#E8F5E9', color: '#1B5E20' }}>
        <h3 className="text-xs font-semibold">Apólices Ativas</h3>
        <p className="text-sm font-bold">{loading ? 'Carregando...' : data?.apolicesAtivas ?? '—'}</p>
      </div>
      
      <div className="p-3 rounded shadow h-24 flex flex-col justify-between" style={{ backgroundColor: '#FFE0DB', color: '#8B2500' }}>
        <h3 className="text-xs font-semibold">Vencidas</h3>
        <p className="text-sm font-bold">{loading ? 'Carregando...' : data?.apolicesVencidas ?? '—'}</p>
      </div>

      <div className="p-3 rounded shadow h-24 flex flex-col justify-between" style={{ backgroundColor: '#ECEFF1', color: '#37474F' }}>
        <h3 className="text-xs font-semibold">Canceladas</h3>
        <p className="text-sm font-bold">{loading ? 'Carregando...' : data?.apolicesCanceladas ?? '—'}</p>
      </div>

      <div className="p-3 rounded shadow h-24 flex flex-col justify-between" style={{ backgroundColor: '#FFF3E0', color: '#E65100' }}>
        <h3 className="text-xs font-semibold">Renovação</h3>
        <p className="text-sm font-bold">{loading ? 'Carregando...' : data?.apolicesRenovacao ?? '—'}</p>
      </div>

      <div className="p-3 rounded shadow h-24 flex flex-col justify-between" style={{ backgroundColor: '#EDE7F6', color: '#4A148C' }}>
        <h3 className="text-xs font-semibold">Propostas Pendentes</h3>
        <p className="text-sm font-bold">{loading ? 'Carregando...' : data?.propostasPendentes ?? '—'}</p>
      </div>
    </div>
  );
};

export default DocumentosCards;